import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFailFull2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Fail_full2"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="url(#Fail_full2_svg__a)"
      fillOpacity={0.25}
    />
    <path
      fill="url(#Fail_full2_svg__b)"
      d="M11 13.4a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
    />
    <path
      fill="url(#Fail_full2_svg__c)"
      d="M9.2 10.4a.8.8 0 0 0 1.6 0V6a.8.8 0 0 0-1.6 0z"
    />
    <defs>
      <linearGradient
        id="Fail_full2_svg__a"
        x1={15}
        x2={-5}
        y1={13.75}
        y2={13.333}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E24664" />
        <stop offset={1} stopColor="#F2ACB9" />
      </linearGradient>
      <linearGradient
        id="Fail_full2_svg__b"
        x1={10.625}
        x2={8.124}
        y1={11.956}
        y2={11.945}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E24664" />
        <stop offset={1} stopColor="#F2ACB9" />
      </linearGradient>
      <linearGradient
        id="Fail_full2_svg__c"
        x1={10.625}
        x2={8.124}
        y1={11.956}
        y2={11.945}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E24664" />
        <stop offset={1} stopColor="#F2ACB9" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFailFull2;
